import { render, staticRenderFns } from "./RenameWine.vue?vue&type=template&id=0343600f&"
import script from "./RenameWine.vue?vue&type=script&lang=js&"
export * from "./RenameWine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports